import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthFacadeService } from '@app/auth/auth-facade.service';
import { UserActionRequestModel } from '@app/auth/models/user-action-request.model';
import { ActionsSubject, Store } from '@ngrx/store';
import { paths } from '@platform/paths';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { deleteClientUser, deleteClientUserFailure, deleteClientUserSuccess } from '@shared/store/client-user/client-user.actions';
import { ButtonDirective } from 'primeng/button';
import { filter, take } from 'rxjs/operators';

enum DeletionStateEnum {
  Deleted,
  Failed,
}

@Component({
  selector: 'cp-deleted',
  imports: [ButtonDirective, IconComponent],
  templateUrl: './deleted.component.html',
  styleUrls: ['../../auth-theme.scss', 'deleted.component.scss'],
  providers: [AuthFacadeService],
})
export class DeletedComponent {
  private readonly store = inject(Store);
  private readonly dispatcher = inject(ActionsSubject);
  private readonly route = inject(ActivatedRoute);
  private readonly facade = inject(AuthFacadeService);

  readonly DeletionStateEnum = DeletionStateEnum;

  protected deletionState: DeletionStateEnum;
  protected queryParams: Partial<UserActionRequestModel>;

  protected readonly paths = paths;

  constructor() {
    this.route.queryParams.subscribe((queryParams: Partial<UserActionRequestModel>) => {
      this.queryParams = queryParams;
      this.store.dispatch(deleteClientUser({ code: this.queryParams.code }));
      this.dispatcher
        .pipe(
          filter((action) => action.type === deleteClientUserSuccess.type || action.type === deleteClientUserFailure.type),
          take(1),
        )
        .subscribe((action) => {
          if (action.type === deleteClientUserSuccess.type) {
            this.deletionState = DeletionStateEnum.Deleted;
          } else {
            this.deletionState = DeletionStateEnum.Failed;
          }
        });
    });
  }

  goToLoginPage(): void {
    this.facade.goToLoginPage();
  }
}
